import React, { forwardRef } from 'react'
import { Input } from 'antd'

import classNames from 'classnames'

import styles from './styles.module.scss'

import type { LntTextAreaProps } from './types'

import type { ForwardRefRenderFunction } from 'react'
import type { InputRef } from 'antd'

const Component: ForwardRefRenderFunction<InputRef, LntTextAreaProps> = (props, ref) => {
  const { className: outerClassName, ...restProps } = props
  const className: string = classNames(styles.lntTextArea, outerClassName)

  return (
    <Input.TextArea
      { ...restProps }
      className={ className }
      ref={ ref }
    />
  )
}

export const LntTextArea = forwardRef<InputRef, LntTextAreaProps>(Component)
